






























import { Vue, Component, Prop } from 'vue-property-decorator'
import icon from 'components/presenter/item/ItemIcon'
import { Item } from 'src/graphql/types'

@Component
export default class ItemFolderContentSubitems extends Vue {
  icon = icon

  @Prop()
  readonly items!: Item[]

  @Prop()
  readonly to!: string
}
